import { render, staticRenderFns } from "./ExamAnswerDetail.vue?vue&type=template&id=4cddbc1b&scoped=true&"
import script from "./ExamAnswerDetail.vue?vue&type=script&lang=js&"
export * from "./ExamAnswerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExamAnswerDetail.vue?vue&type=style&index=0&id=4cddbc1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cddbc1b",
  null
  
)

export default component.exports